import { DraftsRounded } from '@material-ui/icons';
import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function pleitoPosto(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@pleitoposto/FIND_PLEITOPOSTO':
      case '@pleitoposto/UPDATE_PLEITOPOSTO':
      case '@pleitoposto/DELETE_PLEITOPOSTO':
      case '@pleitoposto/STORE_PLEITOPOSTO':
      case '@pleitoposto/PLEITOPOSTO_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@pleitoposto/SUCCESS_REMOVE':
      case '@pleitoposto/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@pleitoposto/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.pleitopostos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@pleitoposto/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.pleitopostos;
        break;
      }

      case '@pleitoposto/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
